export default __webpack_public_path__ + "static/media/Jai-cropped.70395e79.jpeg";